module.exports = __webpack_public_path__ + "img/glass.5fe722af.svg";